module.exports = __webpack_public_path__ + "static/media/Hospitality_45.66269d12.jpg";